<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useInfoSlotsTracker } from '../../model/shift-control/info-slots-tracker.hook'

defineOptions({
  name: 'InfoSlotsTracker',
})

const {
  config,
} = useInfoSlotsTracker()
</script>

<template>
  <div class="info-tracker">
    <div
      v-for="item in config"
      :key="item.text"
      class="info-tracker__item"
      :class="{ 'info-tracker__item--highlighted': item.highlighted }"
    >
      <AppText
        name="body2-medium"
        color="black"
      >
        {{ item.text }}
      </AppText>
      <AppText
        name="body2"
        color="black"
      >
        {{ item.value }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./InfoSlotsTracker.scss" />
